import { Flex, Stack, Text } from "@mantine/core"
import { IconX } from "@tabler/icons";
import { useContext } from "react";
import DiscoveryContext from "../../DiscoveryContext";
import SingleCustomerContext from "../../../Customer360/Customer-Context/SingleCustomerContext";

const CardHeaderDiscoveryAndCustomer = (

  { isDiscoveryPage } :
    { isDiscoveryPage: boolean } 
) => {

  const ContextToUse: React.Context<any> = 
   isDiscoveryPage ? DiscoveryContext : SingleCustomerContext;
  const {
    setChosenEvidence, setCardOpened, setActivityOpened
  } = useContext(ContextToUse);


  const togglePanel = () => {

    setCardOpened((prev: boolean) => !prev);
    setChosenEvidence(null)
    /* setActivityOpened(false) */
  };

  return (
    <>
      <Stack fz="20px" fw={600} h='20px' ta='center' justify="center">
        Evidence details
      </Stack>
      <Flex
        mr='8px'
        sx={{ cursor: " pointer" }}
        onClick={togglePanel}
      >
        <IconX size={16} color="#5C5CEB" />
        <Text ml='3px' color="#5C5CEB" fz={12}>Close</Text>  
      </Flex> 
    </>
  )
}

export default CardHeaderDiscoveryAndCustomer